import { activeStatuses, HandBack, upper, type JanusCtx, type Row } from '../ability/context';
import { statusItemId } from './expiry';

// StatusEffect::STACKED_GROUPS: stages differ in kind; status_stack stays 1.
const FAMILIES: readonly (readonly string[])[] = [
    ['78C6CC42-BCCE-4F22-9FC5-41F8D7E70944', 'EE063289-1AF3-41CF-B73C-64A0556E6D07', '2EAAA2E8-1B9C-196D-3E58-C29C09FF8492', 'A9678CB1-11D3-55A3-E3C9-F342B2E40980'],
    ['611DFED0-9AD1-5500-AF5B-DE7CBD9DDF64', '553734EC-33D3-4527-AB2E-EF48ACED8DF0', '9AA7588A-4575-9550-343D-6ADB0C74C17F', '660E3133-44D8-E79F-C0ED-A26CE31D6E32'],
    ['D98B076A-3A38-E225-B8E3-A646C69AA29D', '430F1BE4-6522-4468-8E27-426B23D003BF', '9EFD0898-7C92-6DE4-DD2F-D6F75ECF3B58', '90FB0BFB-6186-5E01-FD8B-0315D6DFB809'],
];
export function stageRowFamily(id: string): readonly string[] | undefined {
    return FAMILIES.find(family => family.includes(upper(id)));
}
/** Select the new level before retiring anything. A capped application is a no-op;
 * the shared exact remover owns the old row's loss/charge/support/connection tails. */
export function planStageRowApplication(ctx: JanusCtx, target: Row, id: string): { itemId: string; previous?: Row } | null {
    const family = stageRowFamily(id);
    if (!family) return { itemId: id };
    const held = activeStatuses(ctx, target).filter(status => family.includes(statusItemId(status)));
    if (held.length > 1) throw new HandBack('status-stage:ambiguous-family');
    const previous = held[0], current = previous ? Math.max(1, family.indexOf(statusItemId(previous))) : 0;
    const next = Math.min(family.length - 1, current + Math.max(1, family.indexOf(upper(id))));
    return next === current ? null : { itemId: family[next]!, previous };
}
